/* eslint-disable no-underscore-dangle */
import {makeAutoObservable} from 'mobx';
import {Meeting} from 'app/store/models/connect/Meeting/Meeting';
import {RootStore} from 'app/store/RootStore';
import {arrayToMap} from 'app/util/arrayToMap';
import {uniqueNewName} from 'app/util/newName';

export class MeetingsStore {
  root: RootStore;
  private _meetings: Map<string, Meeting> = new Map();
  private _calls: Map<string, App.Connect.Call> = new Map();

  constructor(root: RootStore) {
    this.root = root;
    makeAutoObservable(this, {}, {autoBind: true});
  }

  get meetings() {
    return [...this._meetings.values()];
  }

  set meetings(list: Meeting[]) {
    this._meetings = arrayToMap(list, 'id');
  }

  setMeetings(list: Meeting[]) {
    this._meetings = arrayToMap(list, 'id');
  }

  setMeeting(meeting: Meeting): void {
    this._meetings.set(meeting.id, meeting);
  }

  getMeeting(id: string): Meeting | undefined {
    return this._meetings.get(id);
  }

  removeMeeting(id: string): void {
    this._meetings.delete(id);
  }

  setCall(call: App.Connect.Call) {
    this._calls.set(call.id, call);
  }

  setCalls(list: App.Connect.Call[]) {
    this._calls = arrayToMap(list, 'id');
  }

  get calls() {
    return [...this._calls.values()];
  }

  getCall(id: string) {
    return this._calls.get(id);
  }

  removeCall(id: string) {
    this._calls.delete(id);
  }

  uniqueNewName() {
    return uniqueNewName(
      'My New Meeting',
      this.meetings.map(({name}) => name),
    );
  }
}
